 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import { useObjectState } from "@opendash/core";
import Parse from "parse";
import React from "react";








export function useParseGet(
  cls,
  id,
  options
) {
  const [state, setState, resetState] = useObjectState({
    result: undefined,
    loading: true,
    error: undefined,
    reload: fetch,
  });

  async function fetch() {
    if (cls && id) {
      // @ts-ignore
      const query = new Parse.Query(cls );

      if (_optionalChain([options, 'optionalAccess', _ => _.includes])) {
        for (const include of options.includes) {
          query.include(include);
        }
      }

      query.get(id).then(
        (response) => {
          setState({
            result: response,
            loading: false,
          });
        },
        (error) => {
          setState({ error, loading: false });
        }
      );
    }
  }

  React.useEffect(() => {
    setState({
      result: undefined,
      loading: true,
      error: undefined,
      reload: fetch,
    });

    fetch();
  }, [cls, id]);

  return state;
}
